import React from 'react';
import Contact from '../components/Contact.jsx';
const ContactPage = () => {
    return(
        <div>
            <Contact></Contact>
        </div>
    )
};
export default ContactPage;